export var apiPath="/v1/facilities";var actionType="V2_FACILITIES";export var bulkActionType="".concat(actionType,"_BULK");export default actionType;